var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63157 8.3684C9.66366 8.3684 11.3158 6.71626 11.3158 4.68417C11.3158 2.65209 9.66366 0.999939 7.63157 0.999939C5.59949 0.999939 3.94734 2.65209 3.94734 4.68417C3.94734 6.71626 5.59949 8.3684 7.63157 8.3684ZM7.63157 8.3684C3.97037 8.3684 1 11.3387 1 14.9999M7.63157 8.3684C11.2928 8.3684 14.2632 11.3387 14.2632 14.9999",
    stroke: "#627790",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/team-icon.44c744187a367c2c0794349d9a3fc8ca.svg";
export { ForwardRef as ReactComponent };